module.exports = __webpack_public_path__ + "static/media/back.a4a89d30.svg";